// extracted by mini-css-extract-plugin
module.exports = {"icon":"Item_icon__362z1","phoneInputContainer":"Item_phoneInputContainer__3yACU"};